import { Reveal } from "./Motion";

// Shared interior-page hero (light corporate)
export const PageIntro = ({ label, title, subtitle }) => (
  <section data-testid="page-intro" className="bg-mm-light border-b border-mm-line">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-36 md:pt-44 pb-16 md:pb-20">
      <Reveal>
        <p className="overline mb-5">{label}</p>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-mm-ink max-w-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-lg text-mm-muted max-w-2xl leading-relaxed">{subtitle}</p>}
      </Reveal>
    </div>
  </section>
);
